// ResponsiveMixin을 composition api로 사용
import useWindowSize from './useWindowSize'

export default function useResponsive() {
  const { width } = useWindowSize()

  const isXSmall = () => width < 360
  const isMobile = () => width < 768
  const isMedium = () => width < 900 && width >= 768
  
  return {
    isXSmall,
    isMobile,
    isMedium
  }
}
